<script>
    import axios from 'axios';
    import KSInfiniteTree from '../InfiniteTree/InfiniteTree.vue';
    import {Listeners} from "../../../../../constants/listeners";
    import AdaptersDialog from "../../../../../component/adapters/Dialog.vue";
    import {store} from "../../../store";

    export default {
        data() {
            return {
                name: 'MoveNode',
                loading: false,
                error: null,
                nodeToMove: null,
                pid: 0,
                filter: null,
                superTree: {},
                store: store,
            }
        },
        computed: {
            getUid() {
                return this.store.getters.uid();
            },
            getSelectNodes() {
                return this.store.getters.selectNodes();
            },
            getSetting() {
                return this.store.getters.setting();
            },
            getSettingViewCountWeight() {
                return this.store.getters.settingViewCountWeight();
            },
            apiUrl(){
                return this.$config.API_URL + '/clustering/node/' + this.getUid
            },
            labelInfo() {
                let result = [];
                for (let p in this.getSetting.view.treeNodeName) {
                    if (this.getSetting.view.treeNodeName[p].enabled) {
                        result.push({
                            key: p,
                            color: this.getSetting.view.treeNodeName[p].color,
                            background: this.getSetting.view.treeNodeName[p].background,
                            value: this.model[p].formatMoney(0, ' ', ' '),
                            width: this.getSettingViewCountWeight[p]
                        });
                    }
                }

                return result.reverse();
            },
            childrenCount() {
                return this.isFolder ? " (" + this.model.total_flatten + ")" : "";
            },
            getListenerId() {
                return Listeners.CLUSTER_MOVE_NODE_DIALOG_OPEN;
            },
            getListenerCloseId() {
                return Listeners.CLUSTER_MOVE_NODE_DIALOG_CLOSE;
            }
        },

        methods: {
            move(){
                //this.$events.fire('move-node', {to: this.pid, nodes: this.nodeToMove});
                this.moveNode(this.pid, this.nodeToMove);
                this.onClose();
            },
            moveNode(to, nodes = null) {

                let self = this,
                    fromIds = [],
                    targetNode = this.$parent.$_tree.getNodeById(to);

                let moveNodes = nodes ? nodes : this.getSelectNodes;

                moveNodes.forEach((n) => {
                    if(n.id !== 0 && n.id && -1 && n.id !== -2 && n.id !== -3){
                        let node = this.$parent.$_tree.getNodeById(n.id);
                        let result = this.$parent.$_tree.moveNodeTo(node, targetNode);
                        if(result){
                            fromIds.push(n.id);
                        }

                    }
                });

                this.$parent.$_tree.sortByField(targetNode, this.getSetting.sort);

                if (targetNode.state.open) {
                    self.store.mutations.setNodesInfo(this.$parent.$_tree.getNodesInfo());
                } else {
                    this.$parent.$_tree.openNode(targetNode, {
                        asyncCallback() {
                            self.store.mutations.setNodesInfo(this.$parent.$_tree.getNodesInfo());
                        }
                    });

                }

                if (fromIds.length === 0) {
                    return false;
                }

                this.store.mutations.clearSelectNodes();

                axios({
                    method: 'patch',
                    url: this.apiUrl,
                    withCredentials: true,
                    data: {ids: fromIds, pid: to}
                })
                .catch(function (error) {
                    self.$snotify.error(error.response.data.message, {
                        timeout: 5000,
                        showProgressBar: false,
                    });
                })
            },
            onClose() {
                this.$emitter.emit(this.getListenerCloseId);
            }
        },
        mounted() {
            let self = this;

            this.$emitter.on(Listeners.CLUSTER_MOVE_NODE_DIALOG, nodeToMove => {
                self.superTree = self.$parent.$_tree;

                self.nodeToMove = nodeToMove;
                self.$emitter.emit(self.getListenerId);
            });
        },

        components: {
            'ks-infinite-tree': KSInfiniteTree,
            AdaptersDialog,
        }

    }
</script>
<template>
    <AdaptersDialog
        :listener-id="getListenerId"
        :listener-close-id="getListenerCloseId"
        :header="$t('lang.cluster.move_groups')"
        :loading="loading"
        :error-message="error"
        :callback-agree="move"
        :button-agree-label="$t('lang.main.btn.move')"
    >
        <template #content>
            <div class="field">
                <label class="required">{{$t('lang.cluster.choose_move_folder')}}:</label>
                <ks-infinite-tree :tree="superTree" v-model:pid="pid" :node-disabled="[-1,-2]" :focus="true"></ks-infinite-tree>
            </div>
        </template>
    </AdaptersDialog>
</template>

<style scoped>
    select{width: 100%}
    .radio{
        display: inline;
        padding-right: 10px;
    }
</style>
